module.exports = __webpack_public_path__ + "img/Jorge-Gonzalez.2cb15494.jpg";